import ProductContainer from "../ProductContainer";
import { useParams } from "react-router-dom";
import "./index.css";
import RawMaterialComponents from "./ProdRawMaterials";
import ProdManufacturingComponents from "./ProdManufacturing";
import ProdDeliveriesComponent from "./ProdTransport";
import ProdTravelComponents from "./ProdTravel";
import ProcessingIntermediateComponent from "./ProdProcessing";
import UseOfSoldComponent from "./ProdUseOfSold";
import FinalTreatmentComponent from "./ProdFinalTreatment";
import {
  LovableFlowSeparator,
} from "../ProductDetailsLCA/components/LovableFlowControls";
import { LOVABLE_FLOW_SEPARATOR } from "../ProductDetailsLCA/components/lovableFlowSeparators";

export const ProductDetailView = ({ showCategory, setShowCategory }) => {
  const { productId } = useParams();

  return (
    <ProductContainer>
      <div className="azilis-detail-flows product-detail-view-new-flows">
        <div className="raw-material-relative">
          <RawMaterialComponents
            productId={productId}
            showCategory={showCategory}
            setShowCategory={setShowCategory}
          />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.RAW_MATERIALS}
            label="Between raw materials and manufacturing"
          />
        </div>

        <div className="prod-manufacturing-relative">
          <ProdManufacturingComponents productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.MANUFACTURING}
            label="Between manufacturing and deliveries"
          />
        </div>

        <div className="prod-deliveries-relative">
          <ProdDeliveriesComponent productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.TRANSPORT}
            label="Between deliveries and travel"
          />
        </div>

        <div className="prod-travel-relative">
          <ProdTravelComponents productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.TRANSPORT}
            label="Between travel and processing"
          />
        </div>

        <div className="prod-processing-relative">
          <ProcessingIntermediateComponent productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.SETTINGS}
            label="Between processing and use of sold"
          />
        </div>

        <div className="prod-use-sold-relative">
          <UseOfSoldComponent productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.USE}
            label="Between use of sold and final treatment"
          />
        </div>

        <div className="prod-final-treatment-relative">
          <FinalTreatmentComponent productId={productId} />
        </div>
      </div>
    </ProductContainer>
  );
};
